interface Props {
  lang: string;
  toggleLang: () => void;
}

export default function LandingLanguageButton({ lang, toggleLang }: Props) {
  return (
    <button className="broomwagon-lang-btn" onClick={toggleLang}>
      <i className="bi bi-globe" style={{ fontSize: '0.8rem', marginRight: '6px' }}></i>
      <span style={{ color: lang === 'en' ? '#fff' : '#6c757d' }}>EN</span>
      <span style={{ color: '#495057', margin: '0 4px' }}>/</span>
      <span style={{ color: lang === 'pl' ? '#fff' : '#6c757d' }}>PL</span>
    </button>
  );
}
